<script setup>
import {computed, onMounted, reactive, ref ,defineEmits } from 'vue';
import {Calendar} from 'v-calendar';
import CalendarForm from './CalendarForm';
import {DateTime} from "luxon";
import {useBreadStore} from '@bread/js/store'
import PriceHistoryChart from "@bread/ui/Components/PriceHistoryChart";

const store = useBreadStore()

const props = defineProps([
  'entity','store'
])

const emit = defineEmits(['changed'])

const storesSync = ref(1);

const selectedDate = reactive ({
  id : null,
  store_id : null,
  start_date : null,
  end_date : null,
  price : null,
  product_id:null,
  created_at : null,
  updated_at : null,
})

let error = ref('')

const showError = (data) => {
  error.value = data.message
}

const stores = ref([]);
const selectedStoreIndex = ref(0);

const selectedStore = computed(() => {
  return stores.value[selectedStoreIndex.value]
});

const selectedDates = computed(() => {
  return  stores.value[selectedStoreIndex.value] ?  stores.value[selectedStoreIndex.value].dates : []
})

onMounted(() => {
  getPrices()
})

const getPrices = () => {
  axios.get(
    route('api.products.prices', {
      id: props.entity.id,
    })
  )
    .then((response) => {
      parseResponse(response.data)
    })
}

const parseResponse = (data) => {
  stores.value = [];
  storesSync.value = data.stores_sync ;
  data.stores.forEach( (store) => {

    let storeSchedules = data.schedules.filter(( schedule ) => schedule.store_id === store.id );
    let dates = [];
      storeSchedules.forEach( (schedule ) => {
        dates.push(parseDate(schedule));
      })
    stores.value.push(
      {
      ...store,
      'dates' : dates
      }
    )}
  )
  selectedDate.store_id = selectedStore.value.id;
}

const parseDate = (data) => {
  return {
    highlight: {
      fillMode: 'solid',
      class: 'hidden'
    },
    popover: {
      entity: data,
      label: `€ ${parseFloat(data.price).toFixed(2)}`,
    },
    dates: {
      id : data.id,
      store_id : data.store_id,
      start: new Date(data.start_date),
      end: new Date(data.end_date),
    }
  }
}

const dayClicked = (day) => {
  let today = new Date;
  let newDate = new Date(day.id);

  if (today < newDate) {
    if (day && day.hasOwnProperty('attributes') && day.attributes.length > 0) {
      let attr = {...day.attributes[0].popover.entity};
      Object.keys(attr).forEach((key) => selectedDate[key] = attr[key]);
      //console.log(selectedStore);
    } else {
      Object.keys(selectedDate).forEach((key) => selectedDate[key] = null) //reset dates
      selectedDate.start_date = day.date.toISOString();
      selectedDate.end_date = day.date.toISOString();
      selectedDate.store_id = selectedStore.value.id;
    }
  }
}

const changeStore = (index ) => {
  selectedStoreIndex.value = index;
  selectedDate.store_id = selectedStore.value.id;
  emit('changed' , index);
}

const setDates = (data) => {
  let parsed = []
  data.forEach((date) => {
    parsed.push(parseDate(date))
  })

  if(storesSync){
    stores.value.forEach((store) => store.dates = parsed)
  }else{
    stores.value[selectedStoreIndex.value].dates = parsed;
  }
  //dates.value = parsed
  resetSelectedDate(selectedDate);
}

const locale = {
  id: 'nl',
}

const resetSelectedDate = (selectedDate) => {
  Object.keys(selectedDate).forEach((key) => selectedDate[key] = null)
}

</script>

<template>
  <div class="pt-2 mt-2 border-t">
    <h2 class="text-lg mb-2">
      Prijs-kalender
    </h2>
    <div class="flex justify-start space-x-2 my-4">
      <div v-for="(store ,index ) in stores" :key="index" >
        <button @click="changeStore(index)" :class="{ 'bg-gray-100 border-slate-500' : selectedStoreIndex==index} " class="border border-slate-300 p-2 rounded-md text-sm">{{ store.name }}</button>
      </div>
    </div>

    <div v-if="error" class="space-y-1.5 border border-red-200 bg-red-50 py-2 px-4 text-sm text-red-700">
      {{ error }}
    </div>
    <div class="w-full flex justify-between">
      <div class="w-8/12">
        <Calendar
          is-expanded
          :attributes="selectedDates"
          :show-weeknumbers="true"
          :locale="locale"
        >
          <template #day-content="{ day }">
            <div class="w-full flex items-center justify-start flex-col hover:bg-gray-200">
          <span class="vc-day-content vc-focusable relative"
                :class="{'text-slate': day.hasOwnProperty('attributes') && day.attributes.length > 0}"
                @click="dayClicked(day)">
            {{ day.day }}
          </span>
              <div
                v-if="day.hasOwnProperty('attributes') && day.attributes.length > 0 && day.attributes[0].popover.label"
                class="text-xs">
                {{ day.attributes[0].popover.label }}
              </div>
            </div>
          </template>
        </Calendar>
      </div>
        <CalendarForm
          class=""
          :entity="props.entity"
          :selected="selectedDate"
          :dates="selectedDates"
          @error="showError"
          @saved="getPrices"
        />
    </div>
  </div>
</template>

<style>
@import 'v-calendar/dist/style.css';

.vc-weekday {
  color: rgba(26, 32, 44, .45);
}

.vc-weekday:nth-of-type(7),
.vc-weekday:nth-of-type(8),
.weekday-1,
.weekday-7 {
  background-color: #eff8ff;
  color: rgba(26, 32, 44, .7);
}

.vc-weekday:nth-of-type(7),
.vc-weekday:nth-of-type(8) {
  color: rgba(26, 32, 44, .35);
}

.is-today .vc-day-content {
  border: 1px solid #0070f3;
}

</style>
